import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AcordoComponent } from './acordo/acordo.component';
import { ConsultarPropostaComponent } from './consultar-proposta/consultar-proposta.component';
// import { ConsultarPropostaComponent } from './consultar-proposta/consultar-proposta.component';
import { DetalhePropostaComponent } from './consultar-proposta/detalhe-proposta/detalhe-proposta.component';
import { WindowComponent } from './window/window.component';
import { ReceberHonorarioComponent } from './receber-honorario/receber-honorario.component';
import { PagamentoHonorarioComponent } from './pagamento-honorario/pagamento-honorario.component';
import { DetalheHonorarioComponent } from './pagamento-honorario/detalhe-honorario/detalhe-honorario.component';
import { RepassarValoresAcordoComponent } from './repassar-valores-acordo/repassar-valores-acordo.component';
import { ConsultarLoteFaturaComponent } from './consultar-lote-fatura/consultar-lote-fatura.component';
import { DetalheLoteFaturaComponent } from './consultar-lote-fatura/detalhe-lote-fatura/detalhe-lote-fatura.component';
import { PagadorLoteFaturaComponent } from './pagador-lote-fatura/pagador-lote-fatura.component';
import { ConciliacaoImportarExtratoComponent } from './conciliacao-importar-extrato/conciliacao-importar-extrato.component';
import { ConciliacaoComponent } from './conciliacao/conciliacao.component';
import { ConciliacaoExtratoComponent } from './conciliacao-extrato/conciliacao-extrato.component';
import { ConciliacaoValidacaoComponent } from './conciliacao-validacao/conciliacao-validacao.component';
import { DetalheValidacaoComponent } from './conciliacao-validacao/detalhe-validacao/detalhe-validacao.component';
import { AuthGuard } from './app-authorization';
import { RelatorioAcordoComponent } from './relatorio-acordo/relatorio-acordo.component';
import { RelatorioParcelaComponent } from './relatorio-parcela/relatorio-parcela.component';
import { RelatorioConciliacaoComponent } from './relatorio-conciliacao/relatorio-conciliacao.component';
import { DominioCategoriaDevedorComponent } from './dominio-categoria-devedor/dominio-categoria-devedor.component';
import { DominioContaBancariaComponent } from './dominio-conta-bancaria/dominio-conta-bancaria.component';

const routes: Routes = [
    {
      path: 'acordo',
      component: AcordoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'consultar-proposta',
      component: ConsultarPropostaComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'consultar-proposta/:idAcordo',
      component: ConsultarPropostaComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'receber-honorario',
      component: ReceberHonorarioComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'pagamento-honorario',
      component: PagamentoHonorarioComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'detalhe-honorario/:numeroLoteHonorario',
      component: DetalheHonorarioComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'detalhe-proposta/:idAcordo',
      component: DetalhePropostaComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'repassar-valores-acordo',
      component: RepassarValoresAcordoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'consultar-lote-fatura',
      component: ConsultarLoteFaturaComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'detalhe-lote-fatura/:numeroLoteFatura',
      component: DetalheLoteFaturaComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'pagador-lote-fatura',
      component: PagadorLoteFaturaComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'conciliacao-importar-extrato',
      component: ConciliacaoImportarExtratoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'conciliacao-extrato',
      component: ConciliacaoExtratoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'conciliacao',
      component: ConciliacaoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'conciliacao-validacao',
      component: ConciliacaoValidacaoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'detalhe-validacao/:numeroTransacao',
      component: DetalheValidacaoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'relatorio-acordo',
      component: RelatorioAcordoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'relatorio-parcela',
      component: RelatorioParcelaComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'relatorio-conciliacao',
      component: RelatorioConciliacaoComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'dominio-categoria-devedor',
      component: DominioCategoriaDevedorComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'dominio-conta-bancaria',
      component: DominioContaBancariaComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'window',
      component: WindowComponent
    },
    { 
      path: '**',
      redirectTo: 'not-found' 
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash : true})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
